export default "__VITE_ASSET__BLgkQwCs__"